import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonMenu, TertiaryButton } from '@PipelineDeals/shared-react-components'
import { useBusinessCard } from 'components/BusinessCard/context'

import permissible, { UPDATE, PERSON, COMPANY, DEAL } from 'permissions'
import { PERSON_TYPE, DEAL_TYPE } from 'components/BusinessCard/constants'

import addEditRecord from 'add_edit_modals'
import { OptionsIcon } from 'components/BusinessCard/components/StyledComponents'

const Options = () => {
  const { t } = useTranslation()
  const {
    cardMeta: {
      markPrimary,
      isPrimary,
      showDeleteLink,
      showEditLink
    },
    callbacks: {
      onDeleteLinkClicked,
      onMarkPrimary,
      onClose
    },
    resourceType,
    resourceId
  } = useBusinessCard()

  const renderButton = () => {
    // className is necessary for GlobalSearch/BusinessCard to work properly
    // For example, they are being used in webpack/GlobalSearch/containers/SearchV3.jsx handleOutsideClick function
    // to prevent the clicking of the buttion closing the GlobalSearch/BusinessCard popover
    return (
      <TertiaryButton
        content={<OptionsIcon className="fas fa-ellipsis-v" />}
        className="business-card-options-button"
      />
    )
  }

  const editPolicy = useMemo(() => {
    switch (resourceType) {
      case PERSON_TYPE:
        return PERSON
      case DEAL_TYPE:
        return DEAL
      default:
        return COMPANY
    }
  }, [resourceType])

  const openEditModal = e => {
    e.stopPropagation()

    addEditRecord({ resourceType: resourceType.toLowerCase(), resourceId })

    if (onClose) onClose(false)
  }

  const renderItems = () => {
    // classNames are necessary for GlobalSearch/BusinessCard to work properly
    // For example, they are being used in webpack/GlobalSearch/containers/SearchV3.jsx handleOutsideClick function
    // to prevent the clicking of the buttion closing the GlobalSearch/BusinessCard popover
    return [
      {
        key: 'primary',
        name: t('businessCard.actions.makePrimaryContact'),
        onClick: onMarkPrimary,
        allowed: markPrimary && !isPrimary,
        disabled: !permissible(window.User, PERSON, UPDATE),
        className: 'business-card-option business-card-option-primary',
        'data-cypress': 'bc-mark-primary-contact'
      },
      {
        key: 'edit',
        name: t('common.buttons.edit'),
        onClick: openEditModal,
        allowed: showEditLink,
        disabled: !permissible(window.User, editPolicy, UPDATE),
        className: 'business-card-option business-card-option-edit',
        'data-cypress': `bc-edit-${resourceType}`
      },
      {
        key: 'delete',
        name: t('common.buttons.delete'),
        onClick: onDeleteLinkClicked,
        allowed: showDeleteLink,
        className: 'business-card-option business-card-option-delete',
        'data-cypress': 'bc-disassociate-person'
      }
    ]
  }

  if (!markPrimary && !showEditLink && !showDeleteLink) {
    return null
  }

  return (
    <>
      <ButtonMenu
        button={renderButton()}
        items={renderItems()}
      />
    </>
  )
}

export default Options
